//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import hoofdrichtingen from '~/graphql/queries/hoofdrichtingen.gql';
import specialisaties from '~/graphql/queries/specialisaties.gql';

export default {
  name: 'Hoofdrichtingen',
  apollo: {
    hoofdrichtingen: {
      query: hoofdrichtingen,
    },
    specialisaties: {
      query: specialisaties,
    },
  },
  data: () => ({
    hoofdrichtingen: [],
    specialisaties: [],
    checked: [],
  }),
  computed: {
    hoofdrichtingenOptions() {
      return this.hoofdrichtingen.map(h => ({
        label: h.title,
        value: h.id.toString(),
      }));
    },
    specialisatiesOptions() {
      return this.specialisaties.map(h => ({
        label: h.title,
        value: h.id.toString(),
      }));
    },
  },
  methods: {
    newChecked(val) {
      if (val.length > 3) {
        this.checked.splice(-1);
        this.$toast.error('Je mag maximaal 3 specialisaties kiezen.');
      }
    },
  },
};
